export default __webpack_public_path__ + "static/9-88db61bd613dfa7ac6d5e84c5b4b5645.png";